const subscriptionNames = [
    "AI Model Building",
    "Real-time Surveillance",
    "Product Pricing",
    "Learning Resources",
    //"Manage Users"
    "Behavior Analytics"
];

export default subscriptionNames;